import { BRAND_NAME } from '../../config';
import { MINI_MENU_LINKS } from '../../links';

export const HEADER_ITEMS_LAYOUT = {
  vipSearchPlaceholder: 'Search our exclusive Vip collection!',
};
export const HEADER_LOCATION = {
  changeLocation: 'Change Location',
};
// HEADER - components > header
// folder - header > countdown
export const COUNTDOWN = {
  initialCountDownTime: '00:00:00:00',
  title: 'Deals Refresh In*',
};
// folder - header > mobilenav
export const MOBILE_MENU = {
  accountHead: 'my account',
  menuDownload: 'download app',
  moreHead: 'more options',
  navHead: 'shop by category',
  subscribeHead: 'subscribe',
  viewFooter: 'View Footer',
};

// folder - header > navigation
export const GIFT_FINDER = {
  title: 'Gift Finder',
};
export const HEADER_NAVIGATION = {
  vip: 'VIP',
};
export const HEADER_NAV_NATIONAL_POPOVER = {
  allCategoryDeals: (category) => `All ${category} Deals`,
};
export const HEADER_NAV_POPOVER = {
  allCategoryDeals: (category) => `All ${category} Deals`,
};
export const HEADER_NAV_MORE_ITEM = {
  moreCategories: 'More Categories',
};

export const HEADER_LOCATION_LIST = {
  countryName: 'Scotland',
  dismiss: 'dismiss',
};
export const HEADER_LOGIN = {
  anErrorOccured: 'An error occured',
  login: 'Login',
  logout: 'Logout',
  menu: 'Menu',
};
export const HEADER_LOGOUT = {
  logout: 'Logout',
};
export const HEADER_MOBILE_MENU = {
  appBannerTitle: BRAND_NAME,
};
export const HEADER_SEARCH = {
  searchButtonAriaLabel: 'Start Search',
  searchInputAriaLabel: 'Search the 5pm website',
  searchPlaceholder: 'What are you looking for?',
  suggestionsTitle: 'Suggestions',
  topSearchesTitle: 'Top Searches',
  vip: 'VIP',
};
export const HEADER_SEARCH_DROPDOWN = {
  topSearchesTitle: 'Top Searches',
};
export const HEADER_SUBSCRIBE = {
  continue: 'continue',
  enterValidMail: 'Please enter a valid email',
  signUp: 'Sign Up',
  subscriptionError: 'Error on user subscription.',
  toasterMsg: 'An unexpected error occured. Please try again later.',
  toasterMsgInvalidEmail: 'Invalid Email. Please enter a valid email address',
  yourEmail: 'Your Email',
};
const {
  MY_ACCOUNT_DETAILS,
  MY_GIFT,
  MY_VOUCHERS,
  BECOME_MERCHANT,
  WALLET,
  RAF,
} = MINI_MENU_LINKS;

export const MINI_MENU = [
  { name: 'My Vouchers', value: MY_VOUCHERS },
  { name: 'View Account Details', value: MY_ACCOUNT_DETAILS },
  // { name: 'Claim credit', value: MINI_MENU_CREDIT },
  { name: 'My Wallet', value: WALLET },
  // { name: 'Club Wowcher', value: MINI_MENU_REWARDS },
  // { name: 'Redeem a gift card', value: MINI_MENU_REDEEM },
  { name: 'Claim a gift', value: MY_GIFT },
  { name: 'Become a merchant', value: BECOME_MERCHANT },
];
const RAF_MENU = { name: 'Refer a friend', value: RAF };
export const MY_ACCOUNT_MOBILE_NAV = {
  miniMenu: MINI_MENU,
  rafMenu: RAF_MENU,
};
export const MORE_POPOVER = {
  moreCategories: 'More Categories',
  moreOptions: 'More Options',
};
export const MORE = 'MORE';
